<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      initialValues: {
        title_pl: 'Najbliższe wydarzenia:',
        title_en: 'Upcoming events:'
      }
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
